export const EP = {
    PHONE: '+48221291400',
    PHONE_FORMATTED: '+48 221 291 400',
    EMAIL: 'bok@europlatform.pl'
}